import {
  assertBlockedStatus,
  assertForbiddenTextStatus,
  assertNeedCaptchaStatus,
  assertNeedConfirmPhoneStatus,
  assertSuccessStatus,
  assertUnknownErrorStatus,
  assertUserChatsDisabledStatus,
  assertValidationErrorStatus,
} from '../../assertions';

export const assertions = [
  assertSuccessStatus,
  assertBlockedStatus,
  assertForbiddenTextStatus,
  assertNeedCaptchaStatus,
  assertNeedConfirmPhoneStatus,
  assertUserChatsDisabledStatus,
  assertValidationErrorStatus,
  assertUnknownErrorStatus,
];
